import { render } from "./EditCliente.vue?vue&type=template&id=1fa3907c&scoped=true"
import script from "./EditCliente.vue?vue&type=script&lang=js"
export * from "./EditCliente.vue?vue&type=script&lang=js"

import "./EditCliente.vue?vue&type=style&index=0&id=1fa3907c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa3907c"]])

export default __exports__